module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "calendar-bulk-actions"
  }, [_c('button', {
    staticClass: "do-bttn calendar-bulk-actions__clear",
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("\n    " + _vm._s(_vm.i18n[_vm.locale]['cancel_selection']) + "\n  ")]), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "isCloseOnDropdownClick": true,
      "propOffset": [0, 8]
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('button', {
          staticClass: "do-bttn calendar-bulk-actions__bttn",
          attrs: {
            "id": "vue-popper__massehandling_button"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.i18n[_vm.locale]['bulk_actions']) + " (" + _vm._s(_vm.selectedEventIds.length) + ")\n        "), _c('span', {
          staticClass: "icon-arrow-down5"
        })])]
      },
      proxy: true
    }, {
      key: "list",
      fn: function() {
        return [_c('ul', [_c('li', {
          on: {
            "click": _vm.startBulkCopy
          }
        }, [_c('span', {
          staticClass: "icon-clipboard2"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['copy_events']) + "\n        ")]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.openDeleteModal('cancel')
            }
          }
        }, [_c('span', {
          staticClass: "icon-notification22"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['cancel_events']) + "\n        ")]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.openDeleteModal('uncancel')
            }
          }
        }, [_c('span', {
          staticClass: "icon-checkmark4"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['uncancel_events']) + "\n        ")]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.openDeleteModal('away')
            }
          }
        }, [_c('span', {
          staticClass: "icon-notification22"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['away_events']) + "\n        ")]), _vm._v(" "), _c('li', {
          on: {
            "click": function($event) {
              return _vm.openDeleteModal('unaway')
            }
          }
        }, [_c('span', {
          staticClass: "icon-checkmark4"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['unaway_events']) + "\n        ")]), _vm._v(" "), _c('li', {
          staticClass: "d-item-warning",
          on: {
            "click": function($event) {
              return _vm.openDeleteModal('week')
            }
          }
        }, [_c('span', {
          staticClass: "icon-bin"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete_in_week']) + "\n        ")]), _vm._v(" "), _c('li', {
          staticClass: "d-item-warning",
          on: {
            "click": function($event) {
              return _vm.openDeleteModal('onward')
            }
          }
        }, [_c('span', {
          staticClass: "icon-bin"
        }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete_events_onward']) + "\n        ")])])]
      },
      proxy: true
    }], null, false, 3712525313)
  }), _vm._v(" "), _c('CopyEvent', {
    attrs: {
      "bulk": true
    }
  }), _vm._v(" "), (_vm.isDeleteModal) ? _c('Modal', {
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "bulk-delete__modal text-dark",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "bulk-delete__modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['are_you_sure']))])]), _vm._v(" "), _c('div', {
    staticClass: "bulk-delete__modal__form"
  }, [_c('h4', [_vm._v(_vm._s(_vm.deleteQuestion))]), _vm._v(" "), _c('div', {
    staticClass: "bulk-delete__modal__footer"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.isDeleting
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDeleteModal.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale]['cancel']) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn--warning bttn marg-10-left",
    class: {
      'bttn--red': _vm.deleteMode !== 'uncancel' && _vm.deleteMode !== 'unaway'
    },
    attrs: {
      "disabled": _vm.isDeleting
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [(_vm.isDeleting) ? _c('span', {
    staticClass: "bulk-delete__spinner"
  }) : [_vm._v(_vm._s(_vm.confirmButtonLabel))]], 2)])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b085928!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarBulkActions.vue
// module id = 1785
// module chunks = 1